import { Component, TemplateRef, ViewChild } from "@angular/core";

@Component({
  selector: "ui-carousel-slide",
  templateUrl: "./carousel-slide.component.html",
})
export class CarouselSlideComponent {
  @ViewChild(TemplateRef, { static: true }) templateRef?: TemplateRef<unknown>;
}
